module.exports = __webpack_public_path__ + "media/images/cart-orange-985866e0650424ae38e95b7051e6247d.png";